import { render } from "./SimpleForm.vue?vue&type=template&id=69b15dac&scoped=true"
import script from "./SimpleForm.vue?vue&type=script&lang=js"
export * from "./SimpleForm.vue?vue&type=script&lang=js"

import "./SimpleForm.vue?vue&type=style&index=0&id=69b15dac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-69b15dac"

export default script